import LightSelector from './lightSelector'

export default LightSelector